export class NodeBaseState {
  constructor(node) {
    this.node = node;
  }
}
